import React, { KeyboardEvent, ChangeEvent, ReactElement } from 'react';

export interface Props {
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  value: string | number;
  onBlur?: () => void;
  onFocus?: () => void;
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
  // eslint-disable-next-line @typescript-eslint/ban-types
  containerStyle?: object;
  type?: string;
  disabled?: boolean;
  autoComplete?: string;
  showValidationError?: boolean;
  validationErrorText?: string;
  onRef?: (r: HTMLInputElement) => void;
  onKeyPress?: (e: KeyboardEvent<HTMLInputElement>) => void;
  autoCapitalize?: string;
  autoCorrect?: string;
  autoFocus?: boolean;

  minLength?: number;
}

function Input({
  onChange,
  onBlur = () => {},
  onFocus = () => {},
  placeholder = '',
  className = '',
  style = {},
  containerStyle = {},
  type = 'text',
  disabled = false,
  value,
  autoComplete = '',
  showValidationError = false,
  validationErrorText = '',
  onRef = (r: HTMLInputElement) => {},
  onKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {},
  autoCapitalize = '',
  autoCorrect = '',
  autoFocus = false,
  minLength = 2,
}: {
  onChange?: React.InputHTMLAttributes<HTMLInputElement>['onChange'];
  onBlur?: React.InputHTMLAttributes<HTMLInputElement>['onBlur'];
  onFocus?: React.InputHTMLAttributes<HTMLInputElement>['onFocus'];
  placeholder?: React.InputHTMLAttributes<HTMLInputElement>['placeholder'];
  className?: React.InputHTMLAttributes<HTMLInputElement>['className'];
  style?: React.InputHTMLAttributes<HTMLInputElement>['style'];
  containerStyle?: React.InputHTMLAttributes<HTMLInputElement>['style'];
  type?: React.InputHTMLAttributes<HTMLInputElement>['type'];
  disabled?: React.InputHTMLAttributes<HTMLInputElement>['disabled'];
  value?: React.InputHTMLAttributes<HTMLInputElement>['value'];
  autoComplete?: React.InputHTMLAttributes<HTMLInputElement>['autoComplete'];
  showValidationError?: boolean;
  validationErrorText?: string;
  onRef?: (r: HTMLInputElement) => void;
  onKeyPress?: React.InputHTMLAttributes<HTMLInputElement>['onKeyPress'];
  autoCapitalize?: React.InputHTMLAttributes<HTMLInputElement>['autoCapitalize'];
  autoCorrect?: React.InputHTMLAttributes<HTMLInputElement>['autoCorrect'];
  autoFocus?: React.InputHTMLAttributes<HTMLInputElement>['autoFocus'];
  minLength?: React.InputHTMLAttributes<HTMLInputElement>['minLength'];
}): ReactElement | null {
  return (
    <div className={`${className}`} style={containerStyle}>
      <input
        ref={onRef}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyPress={onKeyPress}
        className={
          showValidationError
            ? 'form-control form__input-error'
            : 'form-control'
        }
        style={style}
        autoComplete={autoComplete}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        autoFocus={autoFocus}
        type={type}
        autoCapitalize={autoCapitalize}
        autoCorrect={autoCorrect}
        minLength={minLength}
      />
      {showValidationError && (
        <div className="form__input-error-text">{validationErrorText}</div>
      )}
    </div>
  );
}

export default Input;
